import React, { useState, lazy, Suspense } from "react";

import { Braces, Eye, FileText, Trash2 } from "lucide-react";

import Modal from "../ui/Modal";

const PdfViewer = lazy(() => import("../common/pdf/PdfViewer"));

export default function PropertyDocumentSection({
  label,
  url,
  hasExtractData = false,
  isAdmin = false,
  onUpdateExtract,
  onDelete,
  isDeletePending = false,
  viewerTitle = "Document",
}) {
  const [showPdf, setShowPdf] = useState(false);

  if (!url) return null;

  return (
    <>
      <div className="property-doc-row">
        <div className="property-doc-identity">
          <span className="property-doc-icon" aria-hidden="true">
            <FileText size={18} strokeWidth={1.75} />
          </span>
          <span className="property-doc-label">{label}</span>
        </div>

        <div className="property-doc-segment" role="group" aria-label={`${label} actions`}>
          <button
            type="button"
            className="property-doc-seg"
            onClick={() => setShowPdf(true)}
            aria-label={`View ${label}`}
            title="View"
          >
            <Eye size={16} strokeWidth={1.75} />
          </button>

          {isAdmin && (    
              <button
                type="button"
                className="property-doc-seg property-doc-seg--danger"
                onClick={onDelete}
                disabled={isDeletePending}
                aria-label={`Delete ${label}`}
                title="Delete file and extracted data"
              >
                <Trash2 size={16} strokeWidth={1.75} />
              </button>
          )}
        </div>
      </div>

      {showPdf && (
        <Modal
          isOpen={showPdf}
          className="brochure-viewer-modal"
          onClose={() => setShowPdf(false)}
          title={viewerTitle}
        >
          <Suspense fallback={<div>Loading PDF...</div>}>
            <PdfViewer fileUrl={url} height="90vh" />
          </Suspense>
        </Modal>
      )}
    </>
  );
}
